export default "__VITE_PUBLIC_ASSET__cc325647__"